<template>
    <ul class="h-admin-menu">
        <li class="h-admin-menu-item"
            v-for="item in menu"
            :class="{active: item[idKey] === current}"
            @click.stop="onItemClick(item)"
            :key="item[idKey]"><span class="name">{{item.name}}</span><h-badge :num="item.num"></h-badge></li>
    </ul>
</template>

<script>
export default {
    name: 'h-menu',
    props: {
        value: {},
        menu: {
            type: Array,
            default () {
                return []
            }
        },
        idKey: {
            type: String,
            default: 'id'
        }
    },
    data () {
        return {
            current: ''
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (val) {
                this.current = val
            }
        }
    },
    methods: {
        onItemClick (item) {
            this.current = item[this.idKey]
            this.$emit('input', this.current)
        }
    }
}
</script>

<style lang="less" scoped>
@import '../color.less';
.h-admin-menu {
    width: 100%;
    height: 100%;
    background: #fff;
    // border-right: 1px solid #dcdfe6;
    &-item {
        position: relative;
        white-space: nowrap;
        cursor: pointer;
        transition: color .3s cubic-bezier(.645,.045,.355,1),border-color .3s cubic-bezier(.645,.045,.355,1),background .3s cubic-bezier(.645,.045,.355,1),padding .15s cubic-bezier(.645,.045,.355,1);
        margin-top: 4px;
        margin-bottom: 4px;
        padding: 0 16px;
        overflow: hidden;
        font-size: 14px;
        line-height: 40px;
        text-overflow: ellipsis;
        &:first-child {
            margin-top: 0;
        }
        &::after {
            content: '';
            position: absolute;
            width: 4px;
            right: 0;
            top: 0;
            opacity: 0;
            transform: scale(0);
            height: 100%;
            transition: all .3s;
            background: @primary;
        }
        &.active {
            background: #e6f7ff;
            color: @primary;
        }
        &.active::after {
            opacity: 1;
            transform: scale(1);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/menu.vue